module.exports = __webpack_public_path__ + "static/media/TN-comingSoon.3c209bb4.png";